var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashIconCircleOrangeDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12688",
    "data-name": "Group 12688",
    transform: "translate(-105 -200)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11966",
    "data-name": "Group 11966",
    transform: "translate(105.651 200.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    transform: "translate(-0.651 -0.65)",
    fill: "#000000ff",
    stroke: "#e3e3e3bb",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.375,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "delete_24dp_5F6368_FILL1_wght400_GRAD0_opsz24",
    d: "M161.154-833.074a.741.741,0,0,1-.543-.226.741.741,0,0,1-.226-.543v-5a.372.372,0,0,1-.274-.111.372.372,0,0,1-.111-.274.372.372,0,0,1,.111-.274.372.372,0,0,1,.274-.111h1.539a.372.372,0,0,1,.111-.274.372.372,0,0,1,.274-.111h1.539a.372.372,0,0,1,.274.111.372.372,0,0,1,.111.274h1.539a.372.372,0,0,1,.274.111.372.372,0,0,1,.111.274.372.372,0,0,1-.111.274.372.372,0,0,1-.274.111v5a.741.741,0,0,1-.226.543.741.741,0,0,1-.543.226Zm1.154-1.539a.373.373,0,0,0,.274-.111.372.372,0,0,0,.111-.274v-2.693a.372.372,0,0,0-.111-.274.372.372,0,0,0-.274-.111.372.372,0,0,0-.274.111.372.372,0,0,0-.111.274V-835a.372.372,0,0,0,.111.274A.373.373,0,0,0,162.309-834.613Zm1.539,0a.373.373,0,0,0,.274-.111.372.372,0,0,0,.111-.274v-2.693a.372.372,0,0,0-.111-.274.372.372,0,0,0-.274-.111.372.372,0,0,0-.274.111.372.372,0,0,0-.111.274V-835a.373.373,0,0,0,.111.274A.373.373,0,0,0,163.848-834.613Z",
    transform: "translate(-50.578 1044.037)",
    fill: "#ef7b13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconCircleOrangeDark);
export default __webpack_public_path__ + "static/media/trash_icon_circle_orange_dark.f74a42d0966a61fc6a83275ba5a5f1d1.svg";
export { ForwardRef as ReactComponent };